import React from "react";
import BookingCard from "../components/BookingComponents/BookingCard";

const booking = () => {
  return (
    <div className="font-roboto">
      <section>
        <BookingCard />
      </section>
    </div>
  );
};

export default booking;
